import { useApostasPorDia, useResumo } from '../api/consultas';
import { CartoesApostas } from '../components/CartoesApostas';
import { ComoLer } from '../components/ComoLer';
import { Estado } from '../components/Estado';
import { Kpi } from '../components/Kpi';
import { fmtDia, fmtInteiro, fmtReais } from '../lib/formato';
import { usePeriodo } from '../lib/periodo';

export function VisaoGeral() {
  const [periodo] = usePeriodo();
  const resumo = useResumo(periodo);
  const apostas = useApostasPorDia(periodo);

  return (
    <section>
      <h1>Visão geral</h1>
      <Estado consulta={resumo}>
        {(r) => {
          const { atual: a, anterior: b } = r.indicadores;
          return (
            <>
              <p className="mudo">
                Comparando com {fmtDia(r.periodoAnterior.de)} a {fmtDia(r.periodoAnterior.ate)}.
              </p>
              <div className="kpis">
                <Kpi
                  titulo="Depósitos pagos"
                  valor={fmtReais(a.depositosPagos.valor)}
                  apoio={`${fmtInteiro(a.depositosPagos.quantidade)} depósitos de ${fmtInteiro(a.depositantes)} jogadores`}
                  atual={a.depositosPagos.valor}
                  anterior={b.depositosPagos.valor}
                  explicacao="Só depósitos aprovados, pela data em que foram gerados."
                />
                <Kpi
                  titulo="Saques pagos"
                  valor={fmtReais(a.saquesPagos.valor)}
                  apoio={`${fmtInteiro(a.saquesPagos.quantidade)} saques`}
                  atual={a.saquesPagos.valor}
                  anterior={b.saquesPagos.valor}
                  subirEhRuim
                  explicacao="Saques aprovados pela data do pedido."
                />
                <Kpi
                  titulo="Líquido"
                  valor={fmtReais(a.liquido)}
                  atual={a.liquido}
                  anterior={b.liquido}
                  explicacao="Depósitos pagos menos saques pagos."
                />
                <Kpi
                  titulo="Primeiros depósitos (FTD)"
                  valor={fmtInteiro(a.ftd.quantidade)}
                  apoio={`${fmtReais(a.ftd.valor)} no primeiro depósito`}
                  atual={a.ftd.quantidade}
                  anterior={b.ftd.quantidade}
                  explicacao="Jogadores cujo primeiro depósito aprovado caiu no período."
                />
                <Kpi
                  titulo="Cadastros"
                  valor={fmtInteiro(a.cadastros)}
                  atual={a.cadastros}
                  anterior={b.cadastros}
                  explicacao="Contas criadas no período."
                />
                <Kpi
                  titulo="Conversão do PIX"
                  valor={a.depositosGerados.quantidade ? `${fmtInteiro(Math.round((a.depositosPagos.quantidade / a.depositosGerados.quantidade) * 100))}%` : '—'}
                  apoio={`${fmtInteiro(a.depositosPagos.quantidade)} pagos de ${fmtInteiro(a.depositosGerados.quantidade)} gerados`}
                  atual={a.depositosGerados.quantidade ? a.depositosPagos.quantidade / a.depositosGerados.quantidade : 0}
                  anterior={b.depositosGerados.quantidade ? b.depositosPagos.quantidade / b.depositosGerados.quantidade : 0}
                  explicacao="Parte dos depósitos gerados que foi paga."
                />
              </div>
            </>
          );
        }}
      </Estado>

      <h2>Apostas</h2>
      <Estado consulta={apostas}>{(c) => <CartoesApostas total={c.total} />}</Estado>

      <ComoLer>
        <p>Os dias seguem o fuso de Brasília e o período é inclusivo. A variação compara com o mesmo número de dias logo antes.</p>
        <p>Os dados vêm da réplica de leitura da Evox e ficam até 5 minutos em cache. Quando a réplica atrasa, uma faixa amarela aparece no topo.</p>
      </ComoLer>
    </section>
  );
}
